import { render, staticRenderFns } from "./NewCotization.vue?vue&type=template&id=36dad382"
import script from "./NewCotization.vue?vue&type=script&lang=js"
export * from "./NewCotization.vue?vue&type=script&lang=js"
import style0 from "./NewCotization.vue?vue&type=style&index=0&id=36dad382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports